// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tr-0";
export var checkoutRateBadgeLink = "_tr-1";